import * as React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Botao } from './botao';

/**
 * Gaveta lateral — regra 2 do blueprint: detalhe NUNCA abre em tela nova.
 * O Radix já fecha com Esc e devolve o foco para quem abriu.
 * Em telas estreitas (coletor) ela vira folha de baixo para cima, porque
 * 400px de largura não comportam um painel lateral útil.
 */
export interface PropsGaveta {
  aberta: boolean;
  aoFechar: () => void;
  titulo: React.ReactNode;
  subtitulo?: React.ReactNode | undefined;
  acoes?: React.ReactNode | undefined;
  children: React.ReactNode;
  className?: string | undefined;
}

export function Gaveta({
  aberta,
  aoFechar,
  titulo,
  subtitulo,
  acoes,
  children,
  className,
}: PropsGaveta): JSX.Element {
  return (
    <Dialog.Root open={aberta} onOpenChange={(v) => !v && aoFechar()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-slate-900/45 backdrop-blur-[2px] data-[state=open]:animate-aparecer" />
        <Dialog.Content
          className={cn(
            'fixed z-50 flex flex-col bg-superficie shadow-forte',
            'inset-x-0 bottom-0 max-h-[85vh] rounded-t-2xl border-t border-borda',
            'sm:inset-y-0 sm:left-auto sm:right-0 sm:max-h-none sm:w-[min(480px,100vw)] sm:rounded-none sm:border-l sm:border-t-0',
            'data-[state=open]:animate-entrarDireita',
            className,
          )}
        >
          <div className="flex items-start justify-between gap-3 border-b border-borda bg-superficie2 px-5 py-3.5">
            <div className="min-w-0">
              <Dialog.Title className="truncate text-[16px] font-bold tracking-[-0.01em]">{titulo}</Dialog.Title>
              {subtitulo ? (
                <Dialog.Description className="mt-0.5 text-xs text-textoFraco">
                  {subtitulo}
                </Dialog.Description>
              ) : (
                <Dialog.Description className="sr-only">Detalhe</Dialog.Description>
              )}
            </div>
            <div className="flex shrink-0 items-center gap-1">
              {acoes}
              <Dialog.Close asChild>
                <Botao variante="fantasma" tamanho="icone" aria-label="Fechar (Esc)">
                  <X className="h-5 w-5" />
                </Botao>
              </Dialog.Close>
            </div>
          </div>
          <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
